export const baseUrl = imgName => {
  return `${process.env.PUBLIC_URL}/assets/${imgName}`;
};
export const isMobile = () => {
  return window.innerWidth < 768;
};
export const isTabletPortrait = () => {
  return window.innerWidth >= 768 && window.innerWidth < 992;
};
